import AppointmentsView from './shared/AppointmentsView';
import { useNavigate } from 'react-router';
import { useAuthUser } from '../../hooks';
import { useUserStatusContext } from '../../contexts/UserStatusContext';
import { ScreenError } from '../../components';

export default function AppointmentsListScreen() {
  const navigate = useNavigate();

  const user = useAuthUser();
  const { myClinicianStatus } = useUserStatusContext();

  const clinicianProfile = myClinicianStatus.user.clinicianProfile;
  if (!clinicianProfile)
    return <ScreenError error={new Error('Clinician has no profile.')} />;

  return (
    <AppointmentsView
      clinicianId={user.id}
      timezone={user.timezone}
      bufferMinutes={clinicianProfile.appointmentBuffer}
      title="Appointments"
      breadcrumbs={[]}
      editButtonText="Edit your schedule"
      onEditClick={() => navigate('/appointments/edit-schedule')}
    />
  );
}
